import { safeDeleteSheet } from "@/lib/office-helpers";

const FLAVORS = [
  "Derroche de chocolate",
  "Derroche de nuez",
  "Trozo de vainilla y frijoles",
  "Jarabe para panqueques",
  "Pavimento de caramelo",
  "Rosquilla de canela",
  "Café de moka",
  "Chocolate de frijole negro",
  "Pistacho y nueces",
  "Chocolate con arándanos",
  "Chocolate picante",
  "Derroche de chocolate del cielo",
  "Trozo de caramelo",
  "Quebrador de fauces de menta",
  "Trufa de nuez y maní",
  "Tarta de queso y caramelo",
  "Galleta Jacker",
  "Chocolate con frambuesa",
  "Chocolate de cereza",
  "Anacardo crujiente",
  "Pedacitos de tocino",
  "Chocolate macizo blanco",
  "Triple chocolate",
];

const COST_ROWS = [
  [2.32, 1.8, 6.5, 4.18],
  [3.25, 0.96, 6.37, 3.12],
  [2.56, 1.28, 5.84, 3.28],
  [2.59, 1.25, 5.83, 3.24],
  [2.05, 1.8, 5.74, 3.69],
  [2.14, 1.65, 5.68, 3.54],
  [1.98, 1.8, 5.55, 3.57],
  [2.28, 1.34, 5.34, 3.06],
  [2.36, 1.2, 5.2, 2.84],
  [1.78, 1.8, 4.99, 3.21],
  [1.77, 1.8, 4.96, 3.19],
  [1.76, 1.8, 4.93, 3.17],
  [1.79, 1.5, 4.48, 2.69],
  [1.54, 1.8, 4.32, 2.78],
  [1.46, 1.8, 4.09, 2.63],
  [1.35, 1.8, 3.78, 2.43],
  [1.28, 1.8, 3.59, 2.31],
  [1.25, 1.8, 3.5, 2.25],
  [1.11, 1.8, 3.11, 2.0],
  [1.5, 1.03, 3.05, 1.55],
  [1.08, 1.8, 3.03, 1.95],
  [0.28, 5.86, 1.93, 1.65],
  [0.35, 2.3, 1.16, 0.81],
];

const SALES = [662, 592, 264, 264, 260, 264, 204, 233, 260, 143, 260, 178, 662, 140, 143, 154, 143, 233, 178, 154, 189, 140, 174];

export async function startProject19(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Costos");
    await safeDeleteSheet(context, "Ganancias");

    const costs = context.workbook.worksheets.add("Costos");
    const profits = context.workbook.worksheets.add("Ganancias");

    costs.getRange("A1:E1").merge();
    costs.getRange("A1").values = [["Masa de galletas"]];
    costs.getRange("A1").format.font.size = 26;
    costs.getRange("A1").format.font.bold = true;
    costs.getRange("A2").values = [["Costos de producción (por libra)"]];
    const costsTable = costs.tables.add("A3:E3", true);
    costsTable.name = "CostosGalletas";
    costsTable.getHeaderRowRange().values = [[
      "Sabores",
      "Costo",
      "Precio fijo",
      "Precio",
      "Margen",
    ]];
    costsTable.rows.add(
      undefined,
      FLAVORS.map((flavor, index) => [flavor, ...COST_ROWS[index]]),
    );
    costsTable.style = "TableStyleLight15";
    costs.getRange("B4:E26").numberFormat = Array(FLAVORS.length).fill([
      "0.00",
      "0.00",
      "0.00",
      "0.00",
    ]);
    costs.getRange("A:A").format.columnWidth = 220;

    profits.getRange("A1:G1").merge();
    profits.getRange("A1").values = [["Masa de galletas"]];
    profits.getRange("A1").format.font.size = 26;
    profits.getRange("A1").format.font.bold = true;
    profits.getRange("A2:G2").merge();
    profits.getRange("A2").values = [["Margen de beneficio (por libra)"]];
    profits.getRange("A2").format.font.bold = true;
    profits.getRange("A2").format.font.size = 14;
    profits.getRange("A2").format.font.color = "#FFFFFF";
    profits.getRange("A2:G2").format.fill.color = "#8B4513";
    profits.getRange("A2").format.horizontalAlignment = "Center";

    const profitRows = FLAVORS.map((flavor, index) => {
      const cost = COST_ROWS[index][0] as number;
      const price = COST_ROWS[index][2] as number;
      const sales = SALES[index];
      const expenses = Number((cost * sales).toFixed(2));
      const income = Number((price * sales).toFixed(2));
      const totalProfit = Number((income - expenses).toFixed(2));
      return [flavor, cost, price, sales, expenses, income, totalProfit];
    });

    const profitsTable = profits.tables.add("A3:G3", true);
    profitsTable.name = "GananciasGalletas";
    profitsTable.getHeaderRowRange().values = [[
      "Sabores",
      "Costo",
      "Precio",
      "Ventas",
      "Costos",
      "Ingresos",
      "Ganancia Total",
    ]];
    profitsTable.rows.add(undefined, profitRows);
    profitsTable.style = "TableStyleLight15";
    profits.getRange("B4:G26").numberFormat = Array(FLAVORS.length).fill([
      "0.00",
      "0.00",
      "0",
      "0.00",
      "0.00",
      "0.00",
    ]);
    profits.getRange("A28").values = [["Costos promedio por sabor"]];

    const chart = profits.charts.add(
      Excel.ChartType.columnClustered,
      profits.getRange("A3:F26"),
      Excel.ChartSeriesBy.columns,
    );
    chart.setPosition("I3", "T22");
    chart.title.text = "Gastos, Sabor, Ingresos y Ganancias";

    costs.activate();
    costs.getRange("A1").select();
    await context.sync();
  });
}
